// extracted by mini-css-extract-plugin
export default {"error":"PageNone_error__AHxi0","error__top":"PageNone_error__top__38Kf2","text":"PageNone_text__pQuil","error__center":"PageNone_error__center__iDXEi","list":"PageNone_list__Rsn+D"};